module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-0-1dcf778684074f055b5271b6f61a0145.jpg";